const formatPercent = (value) => {
  return `${(Number(value)*100).toFixed(2)}%`
}

export default formatPercent;